<template>
  <div>
    <common-dialog ref="dialog" width="1400px" :title="data.batch ? '批量报工' : '报工明细'" id-key="ReportId" :data="data" @closed="onClosed" @edit-opened="openEditOpened" :showSaveButton="false">
      <!-- :get-data-func="api.info" -->
      <template slot="form">
        <div class="row-tb-head">
          <el-row>
            <el-col :span="6">
              <el-form-item label="生产批号">
                {{ data.BatchNumber }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="外协供应商">
                {{ data.ProductionTradeUnitName }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="报工日期"><el-date-picker readonly type="date" v-model="data.ReportDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="changeProductDate" /></el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="质检人员"><select-input readonly placeholder="选择人员" :label="data.TestEmpName" v-model="data.TestEmpId" /></el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-for="item in data.Products" :key="item.Id" style="padding-top: 20px">
      
          <div class="row-tb-head" style="min-height: 40px; height: auto; padding-bottom: 10px">
            <template v-if="data.Stage != 0">
              <el-row style="padding-bottom: 10px">
                <el-col :span="5">
                  <el-form-item label="产品条码"> {{ item.BarCode }} </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="产品名称"> {{ item.ProductName }}</el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="任务数量(个)" label-width="120px"> {{ item.PlanQuantity  }}</el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="完成数量(个)" label-width="120px"> {{ item.ThisReportQuantity }}</el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="产品单重(克)" label-width="110px"> <el-input v-model="item.Grammage" @change="changeGrammage($event, item)"></el-input></el-form-item>
                </el-col>
              </el-row>
            </template>

            <template v-else>
              <el-row  style="padding-bottom: 10px">
                <el-col :span="5">
                  <el-form-item label="产品条码"> {{ item.BarCode }} </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="产品名称"> {{ item.ProductName }}</el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="任务数量(模)" label-width="120px"> {{ iitem.PlanQuantity  }}</el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="任务数量(个)" label-width="120px"> {{ item.PlanQuantity2 }}</el-form-item>
                </el-col>

                <!-- <el-col :span="5">
                <el-form-item label="完成数量(个)" label-width="120px"> {{ item.ThisReportQuantity }}</el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="完成模数" label-width="120px"> {{ item.ReportQuantity }}</el-form-item>
              </el-col> -->
                <el-col :span="5">
                  <el-form-item label="完成数量(个)" label-width="120px"> {{ item.ThisReportQuantity }}</el-form-item>
                </el-col>
              </el-row>
              <el-row  style="padding-bottom: 10px">
                <el-col :span="5">
                  <el-form-item label="产品单重(克)" label-width="110px"> <el-input readonly v-model="item.Grammage" @change="changeGrammage($event, item)"></el-input></el-form-item>
                </el-col>
                
              </el-row>
            </template>
          </div>
          <el-table class="tableList" :data="item.Dts" border style="width: 100%" :summary-method="summaryFunc" show-summary>
            <el-table-column label="序号" prop="Sn" width="50" fixed="left"> </el-table-column>
            <el-table-column label="合格重量(KG)" prop="PassQuantity2" align="center">
              <template slot-scope="{ row }">
                <el-input v-model="row.PassQuantity2" readonly @change="changePassQuantity2(row, item)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="合格数量(个)" prop="PassQuantity" align="center">
              <template slot-scope="{ row }">
                <el-input v-model="row.PassQuantity" readonly @change="changePassQuantity(row, item)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="不合格重量(KG)" prop="FailQuantity2" align="center">
              <template slot-scope="{ row }">
                <el-input v-model="row.FailQuantity2" readonly @change="changeFailQuantity2(row, item)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="不合格数量(个)" prop="FailQuantity" align="center" >
              <template slot-scope="{ row }">
                <el-input v-model="row.FailQuantity" readonly @change="changeFailQuantity(row, item)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="总 重 量(KG)" prop="TotalQuantity2" align="center" >
              <template slot-scope="{ row }">
                <el-input v-model="row.TotalQuantity2" disabled></el-input>
              </template>
            </el-table-column>
            <el-table-column label="总 数 量(个)" prop="TotalQuantity" align="center" >
              <template slot-scope="{ row }">
                <el-input v-model="row.TotalQuantity" disabled></el-input>
              </template>
            </el-table-column>

            <!-- <el-table-column label="操作" min-width="80" align="center" v-if="false" fixed="right">
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click="del(row, $index, item)">删除</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="onSubmit" v-if="false">保存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
      <emp-dialog ref="empDialog2" in-dialog selectable @select="setEmp2" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import empDialog from '@/components/personnel/result/record/listDialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    empDialog
  },
  props: {
    displayMode: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      api: require('@/api/pu/report').default,
      // api: require("@/api/sy/user").default,
      workNo: '',
      data: {
        ReportId: 0,
        PlanId: null,
        PlanDtsId: null,
        Stage: 0,
        StartDate: null,
        EndDate: null,
        ProcessName: '',
        ReportDate: this.$commonJs.getToday(),
        BatchNumber: null,
        Dts: [],
        Materials: [],
        Products: [
          {
            Dts: []
          }
        ],
        operator: '',
        batch: false,
        TestEmpId: null,
        TestEmpName: null,
        ProductDate: this.$commonJs.getToday(),
        ProductStartTime: null,
        ProductEndTime: null,
        ReportQuantity: null,
        CompletionRate: null,
        PlanDtsId: null,
        PlanId: null,
        WorkDocId: null,
        SourceDtsId: null,
        ThisPlanQuantity: null,
        MaintenanceId: null,
        TeamId: null,
        ScheduledId: null,
        StartTime: null,
        EndTime: null,
        State: null,
        EquipmentName: null,
        EquipmentNo: null,
        Team: null,
        Schedule: null,
        IsReport: null,
        IsTest: null,
        Stage: null,
        WorkDocNo: null,
        ProductNo: null,
        ProductName: null,
        MouldNo: null,
        MouldName: null,
        OrderNo: null,
        DpName: null,
        OrderProductNo: null,
        BarCode: null,
        ProductionType: null,
        WorkDocStartTime: null,
        WorkDocEndTime: null,
        ProductionDpId: null,
        WorkDocStatus: null,
        StageName: null,
        PropertyName: null,
        TeamDetails: [],
        EmpIds: [],
        ProductionTradeUnitName: null
        // workInfo: []
      },
      value1: '',
      selectData: {},
      selectRow: {}
    }
  },
  computed: {},
  methods: {
    summaryFunc(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if ((index == 1 || index == 2 || index == 3 || index == 4 || index == 5 || index == 6 || index == 11) && !values.every(value => isNaN(value))) {
          var v = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return Math.floor((prev + curr) * 100) / 100
            } else {
              return prev
            }
          }, 0)
          sums[index] = v
        } else {
          sums[index] = ''
        }
      })

      return sums
    },
    changeTime(row) {
      console.log(row, 'changeTime')
      row.ProductStartTime = row.value1[0]
      row.ProductEndTime = row.value1[1]
      if (row.ProductStartTime && row.ProductEndTime) {
        var startTime = new Date(row.ProductStartTime)
        var endTime = new Date(row.ProductEndTime)
        var time = endTime.getTime() - startTime.getTime()
        time = Number(((time * 0.001) / 3600).toFixed(2))
        row.ProductTime = time
      }
    },
    changeProductDate(val) {
      this.data.Products.forEach(item => {
        item.Dts.forEach(i => {
          i.ProductDate = val
        })
      })
    },
    changeProductTime(val) {
      console.log(val, 'changeTime')
      this.data.ProductStartTime = val[0]
      this.data.ProductEndTime = val[1]
      var time = 0
      if (this.data.ProductStartTime && this.data.ProductEndTime) {
        var startTime = new Date(this.data.ProductStartTime)
        var endTime = new Date(this.data.ProductEndTime)
        time = endTime.getTime() - startTime.getTime()
        time = Number(((time * 0.001) / 3600).toFixed(2))
      }

      console.log(this.data, 'this.data')
      this.data.Products.forEach(item => {
        item.Dts.forEach(i => {
          i.value1 = val
          i.ProductStartTime = this.data.ProductStartTime
          i.ProductEndTime = this.data.ProductEndTime
          i.ProductTime = time
        })
      })
    },
    addList(row) {
      row.Dts.push({
        index: 0,
        Sn: 1,
        PassQuantity: '',
        PassQuantity2: '',
        FailQuantity: '',
        FailQuantity2: '',
        TotalQuantity: '',
        TotalQuantity2: '',
        ReportTeamId: '',
        ReprortEmpId: '',
        ProductDate: '',
        ProductStartTime: '',
        ProductEndTime: '',
        ProductTime: '',
        ProductId: row.ProductId,
        ProductName: row.ProductName,
        BarCode: row.BarCode,
        PlanDtsId: this.data.PlanDtsId,
        PlanId: this.data.PlanId,
        Team: this.data.Team,
        TeamId: this.data.TeamId,
        Schedule: this.data.Schedule,
        ScheduleId: this.data.ScheduleId,
        ProductDate: this.data.ProductDate,
        ProductStartTime: this.data.ProductStartTime,
        ProductEndTime: this.data.ProductEndTime,
        value1: this.value1
      })
      row.Dts.forEach((i, d) => {
        i.index = d
        i.Sn = d + 1
        if (i.ProductStartTime && i.ProductEndTime) {
          var startTime = new Date(i.ProductStartTime)
          var endTime = new Date(i.ProductEndTime)
          var time = endTime.getTime() - startTime.getTime()
          time = Number(((time * 0.001) / 3600).toFixed(2))
          i.ProductTime = time
        }
      })
    },
    del(row, index, item) {
      console.log(item, index, 'del')
      item.Dts.splice(index, 1)
      item.Dts.forEach((i, d) => {
        i.index = d
        i.Sn = d + 1
      })
      if (item.Dts.length == 0) {
        this.addList(item)
      }
    },
    changeGrammage(val, row) {
      if (val) {
        if (row.Dts.length > 0) {
          row.Dts.forEach(item => {
            if (item.PassQuantity2 > 0) {
              item.PassQuantity = parseInt((item.PassQuantity2 * 1000) / val)
            } else if (item.PassQuantity > 0) {
              item.PassQuantity2 = Number(((item.PassQuantity / val) * 1000).toFixed(2))
            }
            if (item.FailQuantity2 > 0) {
              item.FailQuantity = parseInt((item.FailQuantity2 * 1000) / val)
            } else if (item.FailQuantity > 0) {
              item.FailQuantity2 = Number(((item.FailQuantity / val) * 1000).toFixed(2))
            }
            item.TotalQuantity = item.PassQuantity + item.FailQuantity
            item.TotalQuantity2 = item.PassQuantity2 + item.FailQuantity2
          })
        }
      }
    },
    changePassQuantity2(row, item) {
      if (row.PassQuantity2) {
        if (item.Grammage) {
          var quantity = (row.PassQuantity2 * 1000) / item.Grammage
          row.PassQuantity = parseInt(quantity)
        }
      }
      row.TotalQuantity = Number(row.PassQuantity || 0) + Number(row.FailQuantity || 0)
      row.TotalQuantity2 = Number(row.PassQuantity2 || 0) + Number(row.FailQuantity2 || 0)

      if (row.PassQuantity > item.ThisPlanQuantity) {
        this.$message.warning('报工合格数量已超过任务数量，请核查')
        return false
      }
      if (row.TotalQuantity > item.ThisPlanQuantity) {
        this.$message.warning('报工数量已超过任务数量，请核查')
        return false
      }
    },
    changePassQuantity(row, item) {
      if (row.PassQuantity) {
        if (item.Grammage) {
          var quantity = (row.PassQuantity * item.Grammage) / 1000
          row.PassQuantity2 = Number(quantity.toFixed(2))
        }
      }
      row.TotalQuantity = Number(row.PassQuantity || 0) + Number(row.FailQuantity || 0)
      row.TotalQuantity2 = Number(row.PassQuantity2 || 0) + Number(row.FailQuantity2 || 0)

      if (row.PassQuantity > item.ThisPlanQuantity) {
        this.$message.warning('报工合格数量已超过任务数量，请核查')
        return false
      }
      if (row.TotalQuantity > item.ThisPlanQuantity) {
        this.$message.warning('报工数量已超过任务数量，请核查')
        return false
      }
    },
    changeFailQuantity2(row, item) {
      if (row.FailQuantity2) {
        if (item.Grammage) {
          var quantity = (row.FailQuantity2 * 1000) / item.Grammage
          row.FailQuantity = parseInt(quantity)
        }
      }
      row.TotalQuantity = Number(row.PassQuantity || 0) + Number(row.FailQuantity || 0)
      row.TotalQuantity2 = Number(row.PassQuantity2 || 0) + Number(row.FailQuantity2 || 0)

      if (row.FailQuantity > item.ThisPlanQuantity) {
        this.$message.warning('报工不合格数量已超过任务数量，请核查')
        return false
      }
      if (row.TotalQuantity > item.ThisPlanQuantity) {
        this.$message.warning('报工数量已超过任务数量，请核查')
        return false
      }
    },
    changeFailQuantity(row, item) {
      if (row.FailQuantity) {
        if (item.Grammage) {
          var quantity = (row.FailQuantity * item.Grammage) / 1000
          row.FailQuantity2 = Number(quantity.toFixed(2))
        }
      }
      row.TotalQuantity = Number(row.PassQuantity || 0) + Number(row.FailQuantity || 0)
      row.TotalQuantity2 = Number(row.PassQuantity2 || 0) + Number(row.FailQuantity2 || 0)

      if (row.FailQuantity > item.ThisPlanQuantity) {
        this.$message.warning('报工不合格数量已超过任务数量，请核查')
        return false
      }
      if (row.TotalQuantity > item.ThisPlanQuantity) {
        this.$message.warning('报工数量已超过任务数量，请核查')
        return false
      }
    },
    openEmpDialog() {
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },

    setEmp(emp) {
      console.log(emp)
      this.data.TestEmpId = emp.EmpId
      this.data.TestEmpName = emp.EmpName
    },
    openEmpDialog2(row, item) {
      this.selectData = row
      this.selectRow = item
      console.log(row, item, 'en')
      var params = { NoIds: this.data.EmpIds }
      this.$refs.empDialog2.open().then(that => {
        that.getData(params)
      })
    },

    setEmp2(emp) {
      console.log(emp)
      var row = this.selectData
      var item = this.selectRow
      row.ReportEmpId = emp.EmpId
      row.ReportEmpName = emp.EmpName
      console.log(row, item, 'setEmp2')
    },
    chooseSets(data) {
      this.api
        .getWorkDocProductReportList({
          WorkDocNo: data
        })
        .then(res => {
          this.data.Dts = []
          if (res.Data && res.Data.length > 0) {
            res.Data.forEach(item => {
              console.log('item', item)
              //item.ThisReportQuantityNumber = this.displayMode === 1 ? '' : item.ThisPlanQuantity - item.ThisReportQuantity
              item.ThisReportQuantityNumber = null
              item.ThisReportQuantityNumber2 = null
              item.Grammage = null
              this.data.Dts.push(item)
            })
          } else {
            this.$message.warning('暂无数据！')
          }
        })
        .catch(err => {
          this.$message.error(err)
          console.log(err)
        })
      // if (data != '') {
      //   this.data.Dts = this.workInfo.filter(obj => {
      //     const isFilter = data.split('').some((item, index) => {
      //       return  obj.WorkDocNo.split('')[index] !== item
      //     })
      //     return !isFilter
      //   })
      // } else {
      //   this.data.Dts = this.workInfo;
      // }
    },
    onClosed() {
      this.data.Dts = []
      this.data.Materials = []
      this.data.Products = []
      this.workNo = ''
    },
    async openEditOpened(data) {
      console.log(data, 'reportData')
      if (data.TeamDetails) {
        this.data.EmpIds = data.TeamDetails.map(x => x.EmpId)
      }

      console.log(this.data.EmpIds, 'empids')
      this.operator = JSON.parse(localStorage.getItem('loginInfo')).UserName
      var thisPlanQuantity = data.ReportQuantity
      var products = JSON.parse(JSON.stringify(this.data.Products))
      products.forEach(item => {
        this.data.BatchNumber = item.BatchNumber
        item.PlanQuantity = data.PlanQuantity
        item.PlanQuantity2 = data.PlanQuantity * item.RubberQuantity
        item.Dts.forEach((i, d) => {
          i.TotalQuantity = i.PassQuantity + i.FailQuantity
          i.TotalQuantity2 = i.PassQuantity2 + i.FailQuantity2

          i.index = d
          i.Sn = d + 1
        })
      })
      this.data.Products = products
      console.log(products, this.data.Products, 'reportData')
      // this.api.getPlanProductModel({ Id: data.WorkDocId, PlanQuantity: thisPlanQuantity }).then(res => {
      //   console.log(res, 'getPlanProductModel')
      //   if (res.Code == 0) {
      //     var pdata = res.Data
      //     if (pdata.Stage == 0) {
      //       this.data.Products = pdata.ProductModels[0].BomRubbers
      //       this.data.Products.forEach(item => {
      //         item.PlanDtsId = this.data.PlanDtsId
      //         item.PlanId = this.data.PlanId
      //         item.Team = this.data.Team
      //         item.TeamId = this.data.TeamId
      //         item.Schedule = this.data.Schedule
      //         item.ScheduleId = this.data.ScheduleId
      //         console.log(this.data.PlanDtsId)
      //         item.ThisPlanQuantity = item.NeedQuanity
      //         item.Dts = [
      //           {
      //             index: 0,
      //             Sn: 1,
      //             PassQuantity: '',
      //             PassQuantity2: '',
      //             FailQuantity: '',
      //             FailQuantity2: '',
      //             TotalQuantity: '',
      //             TotalQuantity2: '',
      //             ReportTeamId: '',
      //             ReprortEmpId: '',
      //             ProductDate: this.data.ProductDate,
      //             ProductStartTime: '',
      //             ProductEndTime: '',
      //             ProductTime: '',
      //             ProductId: item.ProductId,
      //             ProductName: item.ProductName,
      //             BarCode: item.BarCode,
      //             Team: this.data.Team,
      //             TeamId: this.data.TeamId,
      //             Schedule: this.data.Schedule,
      //             ScheduleId: this.data.ScheduleId,
      //             PlanDtsId: this.data.PlanDtsId,
      //             PlanId: this.data.PlanId,
      //             ProductStartTime: this.data.ProductStartTime,
      //             ProductEndTime: this.data.ProductEndTime,
      //             value1: this.value1
      //           }
      //         ]
      //         item.Dts.forEach((i, d) => {
      //           i.index = d
      //           i.Sn = d + 1
      //           if (i.ProductStartTime && i.ProductEndTime) {
      //             var startTime = new Date(i.ProductStartTime)
      //             var endTime = new Date(i.ProductEndTime)
      //             var time = endTime.getTime() - startTime.getTime()
      //             time = Number(((time * 0.001) / 3600).toFixed(2))
      //             i.ProductTime = time
      //           }
      //         })
      //       })
      //     } else {
      //       this.data.Products = pdata.ProductModels
      //       this.data.Products.forEach(item => {
      //         item.PlanDtsId = this.data.PlanDtsId
      //         item.PlanId = this.data.PlanId
      //         item.ThisPlanQuantity = thisPlanQuantity
      //         item.Dts = [
      //           {
      //             index: 0,
      //             Sn: 1,
      //             PassQuantity: '',
      //             PassQuantity2: '',
      //             FailQuantity: '',
      //             FailQuantity2: '',
      //             TotalQuantity: '',
      //             TotalQuantity2: '',
      //             ReportTeamId: '',
      //             ReprortEmpId: '',
      //             ProductDate: this.data.ProductDate,
      //             ProductStartTime: '',
      //             ProductEndTime: '',
      //             ProductTime: '',
      //             ProductId: item.ProductId,
      //             ProductName: item.ProductName,
      //             BarCode: item.BarCode,
      //             Team: this.data.Team,
      //             TeamId: this.data.TeamId,
      //             Schedule: this.data.Schedule,
      //             ScheduleId: this.data.ScheduleId,
      //             PlanDtsId: this.data.PlanDtsId,
      //             PlanId: this.data.PlanId,
      //             ProductStartTime: this.data.ProductStartTime,
      //             ProductEndTime: this.data.ProductEndTime,
      //             value1: this.value1
      //           }
      //         ]
      //         item.Dts.forEach((i, d) => {
      //           i.index = d
      //           i.Sn = d + 1
      //           if (i.ProductStartTime && i.ProductEndTime) {
      //             var startTime = new Date(i.ProductStartTime)
      //             var endTime = new Date(i.ProductEndTime)
      //             var time = endTime.getTime() - startTime.getTime()
      //             time = Number(((time * 0.001) / 3600).toFixed(2))
      //             i.ProductTime = time
      //           }
      //         })
      //       })
      //     }
      //     console.log(this.data.Products, 'reportData')
      //   }
      // })

      // this.data.Dts = data.infoData;
      // // this.workInfo = data.infoData;
      // this.data.batch = data.batch;
      // let o = {}
      // let infoData = []
      // if (data.batch) {
      //   const ids = data.checkList.map(item => item.WorkDocId)
      //   o = { WorkDocIds: ids }
      // } else {
      //   o = {
      //     WorkDocId: data.row.WorkDocId,
      //     WorkDocNo: data.row.WorkDocNo,
      //     PlanDtsId: data.row.PlanDtsId
      //   }
      // }
      // const res = await this.api.getWorkDocProductReportList(o)
      // if (!res.IsSucc) return this.$message.error(res.Msg)
      // if (res.Data && res.Data.length > 0) {
      //   infoData = res.Data
      // }
      // // this.edit({infoData: this.$refs.toCheckList.workInfo, batch: true})
      // this.data.Dts = infoData.map(item => {
      //   return {
      //     ...item,
      //     ThisReportQuantityNumber: null,
      //     ThisReportQuantityNumber2: null,
      //     Grammage: null,
      //     PlanDtsId: data.row.PlanDtsId,
      //     PlanId: data.row.PlanId
      //     //ThisReportQuantityNumber: this.displayMode === 1 ? '' : item.ThisPlanQuantity - item.ThisReportQuantity
      //   }
      // })
      // this.data.batch = data.batch
    },
    async onSubmit() {
      let isReturn = false
      var data = JSON.parse(JSON.stringify(this.data))

      if (data.TestEmpId == null || data.TestEmpId == 0 || data.TestEmpId == undefined) {
        this.$message.error('请选择质检人员')
        isReturn = true
      }

      if (data.ProductDate == null || data.ProductDate == undefined) {
        this.$message.error('请选择生产日期')
        isReturn = true
      }

      if (data.ProductStartTime == null || data.ProductStartTime == undefined || data.ProductEndTime == null || data.ProductEndTime == undefined) {
        this.$message.error('请选择生产开始结束时间')
        isReturn = true
      }
      var products = data.Products
      for (let i = 0; i < products.length; i++) {
        const item = products[i]
        if (item.Grammage == null || item.Grammage == undefined) {
          this.$message.error('请输入产品单重')
          isReturn = true
          return
        }
        item.PassQuantity = Number(item.PassQuantity || 0)
        item.PassQuantity2 = Number(item.PassQuantity2 || 0)
        item.FailQuantity = Number(item.FailQuantity || 0)
        item.FailQuantity2 = Number(item.FailQuantity2 || 0)
        for (let j = 0; j < item.Dts.length; j++) {
          const dts = item.Dts[j]
          if (dts.PassQuantity == null || dts.PassQuantity == undefined) {
            this.$message.error('请输入合格数量')
            isReturn = true
            return
          }

          if (dts.PassQuantity2 == null || dts.PassQuantity2 == undefined) {
            this.$message.error('请输入合格重量')
            isReturn = true
            return
          }
          dts.Grammage = item.Grammage
          dts.PassQuantity = Number(dts.PassQuantity ?? 0)
          dts.PassQuantity2 = Number(dts.PassQuantity2 ?? 0)
          dts.FailQuantity = Number(dts.FailQuantity ?? 0)
          dts.FailQuantity2 = Number(dts.FailQuantity2 ?? 0)
          item.PassQuantity = Number(item.PassQuantity ?? 0) + Number(dts.PassQuantity ?? 0)
          item.PassQuantity2 = Number(item.PassQuantity2 ?? 0) + Number(dts.PassQuantity2 ?? 0)
          dts.ThisReportQuantity = Number(dts.TotalQuantity ?? 0)
          dts.ThisReportQuantity2 = Number(dts.TotalQuantity2 ?? 0)
        }

        if (data.Stage == 0) {
          item.mouldRate = parseInt(item.PassQuantity / item.Quantity)
        }
      }
      products.sort((a, b) => a.mouldRate - b.mouldRate)
      if (data.Stage == 0) {
        data.ThisReportQuantity = products[0].mouldRate
      } else {
        data.ThisReportQuantity = products[0].PassQuantity
      }
      data.Products = products
      // const arr = this.data.Dts.map(item => {
      //   if (item.ThisReportQuantityNumber == null || item.ThisReportQuantityNumber == undefined) {
      //     this.$message.error('请输入本次报工数')
      //     isReturn = true
      //   }

      //   if (item.ThisReportQuantityNumber2 == null || item.ThisReportQuantityNumber2 == undefined) {
      //     this.$message.error('请输入本次报工数（kg）')
      //     isReturn = true
      //   }

      //   if (item.Grammage == null || item.Grammage == undefined) {
      //     this.$message.error('请输入本次克重')
      //     isReturn = true
      //   }

      //   if (item.EmpId == null || item.EmpId == undefined) {
      //     this.$message.error('请选择本次报工员工')
      //     isReturn = true
      //   }
      //   return {
      //     WorkDocId: item.WorkDocId,
      //     ThisReportQuantity: Number(item.ThisReportQuantityNumber),
      //     ThisReportQuantity2: Number(item.ThisReportQuantityNumber2),
      //     Grammage: Number(item.Grammage),
      //     WorkDocProcessId: item.WorkDocProcessId,
      //     EmpId: item.EmpId,
      //     PlanId: item.PlanId,
      //     PlanDtsId: item.PlanDtsId
      //   }
      // })
      if (isReturn) return
      console.log(data, 'submit')
      const res = await this.api.submit(data)
      if (!res.IsSucc) return this.$message.error(res.Msg)
      this.$message.success('保存成功！')
      this.$refs.dialog.isChange = false
      this.close()
      this.$emit('saved')
    },
    close() {
      this.$refs.dialog.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.inline_block {
  display: inline-block;
}
.mrx36 {
  margin-right: 36px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0;
}
</style>